import React from 'react';
import { Tooltip, BaseButton } from '@enter/core';
import Icon from '@mdi/react';
import { mdiInformation } from '@mdi/js';
import { DynamicDetails } from './dynamic-details';

interface DynamicCardProps {
    sectionLabel: string;
    valueLabel: string;
    data: any;
    dialogContext: any;
}

export const DynamicCard: React.FC<DynamicCardProps> = ({
    sectionLabel,
    valueLabel,
    data,
    dialogContext,
}) => {
    const openDetails = () => {
        const dialogProps = {
            props: {
                onClose: () => {
                    if (dialogContext.closeModal) {
                        dialogContext.closeModal();
                    } else if (dialogContext.hideDialog) {
                        dialogContext.hideDialog();
                    }
                },
                disableBackdropClick: true,
                disableEscapeKeyDown: true,
                renderTitle: `${sectionLabel} Details`,
                renderActions: (
                    <BaseButton 
                        type="button" 
                        onClick={() => {
                            if (dialogContext.closeModal) {
                                dialogContext.closeModal();
                            } else if (dialogContext.hideDialog) {
                                dialogContext.hideDialog();
                            }
                        }} 
                        variant="outlined"
                    >
                        Cancel
                    </BaseButton>
                ),
            },
            Component: (
                <div style={{ width: '800px', maxWidth: '800px', minWidth: '800px' }}>
                    <DynamicDetails data={data} />
                </div>
            ),
        };

        if (dialogContext.openModal) {
            dialogContext.openModal(dialogProps);
        } else if (dialogContext.showDialog) {
            dialogContext.showDialog(dialogProps);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={{ 
                color: '#6c757d', 
                fontSize: '14px', 
                fontWeight: 500,
                marginBottom: '4px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
            }}>
                {sectionLabel}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '16px', fontWeight: 500 }}>{valueLabel || 'N/A'}</span>
                {data && (
                    <Tooltip
                        direction="top"
                        variant="dark"
                        title={<span>View {sectionLabel} Details</span>}>
                        <div 
                            style={{ cursor: 'pointer', color: '#6c757d', display: 'inline-flex', alignItems: 'center' }}
                            onClick={openDetails}
                        >
                            <Icon path={mdiInformation} size={0.8} />
                        </div>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};

